import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openHeatmap as openHeatmapAction, closeHeatmap as closeHeatmapAction } from '@Pages/Heatmap/actions';
import { useLocation } from 'react-router-dom';

const HEATMAP_BODY_CLASS = 'heatmap-is-visible';
const FULLSCREEN_CLASS = 'fullscreen';

export default function useFullScreenMode(open, fullScreenMode) {
  const location = useLocation().pathname;
  const dispatch = useDispatch();
  useEffect(() => {
    if (location.indexOf('heatmap') > -1) {
      dispatch(openHeatmapAction());
      if (open) {
        document.body.classList.add(HEATMAP_BODY_CLASS);
      }
      if (fullScreenMode) {
        document.body.classList.add(FULLSCREEN_CLASS);
      }
    }

    return () => {
      document.body.classList.remove(HEATMAP_BODY_CLASS);
      document.body.classList.remove(FULLSCREEN_CLASS);
      dispatch(closeHeatmapAction());
    };
  }, [location, dispatch, open, fullScreenMode]);
}
